'use client'

import { usePageId } from '@marketplace-web/environment/request-context-data'
import { useSession } from '@marketplace-web/shared/session-data'

import TrackWebVitals from '../TrackWebVitals'

type Props = Omit<React.ComponentProps<typeof TrackWebVitals>, 'screen' | 'pageId'>

// TODO: test me
const SessionTrackWebVitals = (props: Props) => {
  const { screen } = useSession()
  const pageId = usePageId()

  if (!pageId) return null

  return <TrackWebVitals {...props} screen={screen} pageId={pageId} />
}

export default SessionTrackWebVitals
